﻿{
  "createAccount": "Opprett konto",
  "subscription": "Abonnement",
  "oneTimePurchase": "Engangskjøp",
  "billingDetails": "Faktureringsdetaljer",
  "paymentDetails": "Betalingsdetaljer",
  "requestAQuote": "Forespørselsskjema for organisasjoner",
  "reviewOrder": "Gjennomgå ordre",
  "thankYouForYourOrder": "Takk for din ordre!",
  "joinTheCommunity": "Bli med i fellesskapet",
  "startTrial": "Start prøveperiode",
  "yourTrialHasEnded": "Prøveperioden er utløpt",
  "taxExempt": "Skattefritatt",
  "taxExemptThankYou": "Opplastingen var vellykket",
  "planDetails": "Mine abonnementsdetaljer",
  "modifyPlan": "Endre abonnement",
  "modifyPaymentDetails": "Endre betalingsdetaljer",
  "redirect": "Omdirigerer til Boardmaker",
  "perpetualTrial": "Last ned din {{trialLength}}-dagers gratis prøveperiode",
  "perpetualThankYou": "Programvaren er klar!",
  "downloads": "Last ned Boardmaker",
  "partner": "Finn en partner",
  "intro": "Velg et Boardmaker-produkt nedenfor for å laste ned den siste versjonen for enheten din.",
"systemRequirements": "Systemkrav",
"releaseNotes": "Versjonsmerknader",
"comparison": "Sammenligne abonnement og lisens"
}
